import { Kedo } from '../../../../Kedo'

export const getRecurrentOptions = (kedo: Kedo) => [
    { name: kedo.t('Daily'), value: 'daily' },
    { name: kedo.t('Weekly'), value: 'weekly' },
    { name: kedo.t('monthly'), value: 'monthly' },
    { name: kedo.t('yearly'), value: 'yearly' },
]

export const getShortDays = (kedo: Kedo) => [
    { name: kedo.t('days_short.Sun'), value: 'Sunday' },
    { name: kedo.t('days_short.Mon'), value: 'Monday' },
    { name: kedo.t('days_short.Tue'), value: 'Tuesday' },
    { name: kedo.t('days_short.Wed'), value: 'Wednesday' },
    { name: kedo.t('days_short.Thu'), value: 'Thursday' },
    { name: kedo.t('days_short.Fri'), value: 'Friday' },
    { name: kedo.t('days_short.Sat'), value: 'Saturday' },
]

export const getShortMonths = (kedo: Kedo) => [
    { name: kedo.t('months_short.Jan'), value: '1' },
    { name: kedo.t('months_short.Feb'), value: '2' },
    { name: kedo.t('months_short.Mar'), value: '3' },
    { name: kedo.t('months_short.Apr'), value: '4' },
    { name: kedo.t('months_short.May'), value: '5' },
    { name: kedo.t('months_short.Jun'), value: '6' },
    { name: kedo.t('months_short.Jul'), value: '7' },
    { name: kedo.t('months_short.Aug'), value: '8' },
    { name: kedo.t('months_short.Sep'), value: '9' },
    { name: kedo.t('months_short.Oct'), value: '10' },
    { name: kedo.t('months_short.Nov'), value: '11' },
    { name: kedo.t('months_short.Dec'), value: '12' },
]

export const isValidNumericInput = (
    value: string,
    event: React.FormEvent<HTMLInputElement>
): boolean => {
    const inputEvent = event.nativeEvent as InputEvent

    return (
        (/^[0-9]+$/.test(value) && value.length < 4) ||
        ['deleteContentBackward', 'deleteContentForward'].includes(
            inputEvent?.inputType || ''
        )
    )
}
